module.exports = __webpack_public_path__ + "img/ueber ng grafikdesign dortmund.e71eaffa.svg";